import { render, staticRenderFns } from "./BuildingProductionCompact.vue?vue&type=template&id=fa897f00&"
import script from "./BuildingProductionCompact.vue?vue&type=script&lang=js&"
export * from "./BuildingProductionCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports